import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { PopupProvider } from "./components/PopupContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID!;
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <AuthProvider>
        <PopupProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </PopupProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
